import React, { PropsWithChildren, useState } from 'react';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { AlertGroupName, useAlertState } from '../../hooks/useAlertState/useAlertState';
import { AlertBase, IBaseAlertProps } from './AlertBase';

export interface IAlertProps extends IBaseAlertProps {}

export const Alert = React.forwardRef<HTMLDivElement, PropsWithChildren<IAlertProps>>((props, ref) => {
  const { id = '', groupName = AlertGroupName.Alert, onClose, children } = props;
  const { generateTestId } = useTestId(props, `Alert${id ? `-${id}` : ``}`);
  const { removeAlertState } = useAlertState(groupName);
  const [closed, setClosed] = useState(false);

  const handleOnClose = (e: React.MouseEvent<HTMLElement>) => {
    e?.stopPropagation();
    setClosed(true);
    removeAlertState(groupName, id);

    onClose?.(e);
  };

  if (closed) {
    return <></>;
  }

  return (
    <AlertBase {...generateTestId()} {...props} ref={ref} onClose={handleOnClose}>
      {children}
    </AlertBase>
  );
});
